import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';
import WaveUIInput from '@/shared/components/forms/WaveUIInput';

type ApiKeyViewDialogProps = {
  apiKey: string;
  onClose: () => void;
};

const ApiKeyViewDialog: FC<ApiKeyViewDialogProps> = ({ apiKey, onClose }) => {
  const { t } = useTranslation(['paymentProcessors', 'common']);

  const writeClipboardText = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalNotification
      size='sm'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('paymentProcessors:viewApiKey'),
        content: (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 0.5,
              py: 1,
            }}
          >
            <WaveUIInput
              name='apiKey'
              placeholder={t('paymentProcessors:api_key')}
              label={t('paymentProcessors:api_key')}
              value={apiKey}
              multiline
              readOnly
              rows={8}
            />

            <IconButton onClick={() => writeClipboardText(apiKey)}>
              <ContentCopyOutlinedIcon
                sx={{
                  color: 'text.secondary',
                  width: 16,
                  height: 16,
                }}
              />
            </IconButton>
          </Box>
        ),
        actions: [
          {
            label: t('common:close'),
            onClick: onClose,
          },
        ],
      }}
    />
  );
};

export default ApiKeyViewDialog;
